import React, { useState } from 'react';
import { formatExactShareMoney, formatUsd } from '../../data/countries';
import { computeMarketplaceTradeFees } from '../../utils/marketplace';

const MarketplaceBuyModal = ({ listing, property, balance, onClose, onConfirm, country, buying = false }) => {
  const [shares, setShares] = useState(1);
  if (!listing) return null;

  const maxShares = Math.max(1, Number(listing.shares) || 1);
  const safeShares = Math.min(Math.max(1, shares), maxShares);
  const fees = computeMarketplaceTradeFees(listing.pricePerShare, safeShares);
  const canAfford = balance + 0.001 >= fees.buyerPaysUsd;
  const balanceAfter = Math.round((balance - fees.buyerPaysUsd) * 100) / 100;
  const title = property?.title || listing.propertyTitle || 'Property listing';

  return (
    <div className="modal-overlay active" onClick={(e) => e.target === e.currentTarget && !buying && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>Buy Shares — {title}</h2>
          <button type="button" className="modal-close" onClick={onClose} disabled={buying}>&times;</button>
        </div>
        <div className="modal-body">
          <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginBottom: '1rem' }}>
            You are buying from {listing.seller || 'another investor'} on the secondary marketplace.
            A 1% platform fee is added to your total. The seller receives the trade amount minus a 1% fee.
          </p>
          <div className="investment-summary">
            <div className="summary-row"><span>Seller</span><span>{listing.seller || 'Investor'}</span></div>
            <div className="summary-row"><span>Price / share</span><span>{formatExactShareMoney(listing.pricePerShare, country)}</span></div>
            <div className="summary-row"><span>Shares to buy</span><span>{safeShares}</span></div>
            <div className="summary-row"><span>Trade amount</span><span>{formatUsd(fees.tradeAmountUsd, { minDecimals: 2 })}</span></div>
            <div className="summary-row"><span>Platform fee (1%)</span><span>{formatUsd(fees.buyerFeeUsd, { minDecimals: 2 })}</span></div>
            <div className="summary-row" style={{ fontWeight: 700 }}>
              <span>Total charged</span>
              <span>{formatUsd(fees.buyerPaysUsd, { minDecimals: 2 })}</span>
            </div>
            <div className="summary-row"><span>Your wallet balance</span><span>{formatUsd(balance)}</span></div>
            <div className="summary-row" style={{ fontWeight: 700, color: canAfford ? 'inherit' : 'var(--danger, #c0392b)' }}>
              <span>Balance after purchase</span>
              <span>{canAfford ? formatUsd(balanceAfter) : 'Insufficient funds'}</span>
            </div>
          </div>
          {maxShares > 1 && (
            <div className="form-group">
              <label htmlFor="marketplace-buy-shares">Shares</label>
              <input
                id="marketplace-buy-shares"
                type="number"
                min="1"
                max={maxShares}
                value={safeShares}
                onChange={(e) => setShares(parseInt(e.target.value, 10) || 1)}
              />
              <input
                type="range"
                min="1"
                max={maxShares}
                value={safeShares}
                onChange={(e) => setShares(parseInt(e.target.value, 10))}
              />
            </div>
          )}
          <button
            type="button"
            className="btn btn-accent"
            style={{ width: '100%', padding: '1rem' }}
            disabled={!canAfford || buying}
            onClick={() => onConfirm(safeShares)}
          >
            {buying ? 'Processing…' : canAfford ? `Confirm purchase — ${formatUsd(fees.buyerPaysUsd, { minDecimals: 2 })}` : 'Insufficient funds'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceBuyModal;
